export default {
  namespace: 'goodsdetails',
  state: {
    specCheckObj: {},
    specMap: {},
    specNames: [],
    specValues: [],
    goodsSpec: [],
  },
  reducers: {
    save(state, { payload }) {
      const { specCheckObj, specMap } = payload;

      return { ...state, specCheckObj, specMap };
    },
    saveSpecNames(state, { payload }) {
      const { specNames } = payload;

      return { ...state, specNames };
    },
    saveSpecValues(state, { payload }) {
      const { specValues } = payload;

      return { ...state, specValues };
    },
    saveGoodsSpec(state, { payload }) {
      const { goodsSpec } = payload;

      return { ...state, goodsSpec };
    },
    saveBasicInfo(state, { payload }) {
      const { basicInfo } = payload;

      return { ...state, basicInfo };
    },
    savePriceInfo(state, { payload }) {
      const { priceInfo } = payload;

      return { ...state, priceInfo };
    },
    saveImgInfo(state, { payload }) {
      const { imgInfo } = payload;

      return { ...state, imgInfo };
    },
    saveProductImgInfo(state, { payload }) {
      const { productImgs } = payload;

      return { ...state, productImgs };
    },
    clearAllInfo() {
      return { specCheckObj: {}, specMap: {}, specNames: [], specValues: [], goodsSpec: [] };
    },
  },
};
